import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { User } from "src/app/models/user-model";
import { AuthService } from "src/app/services/auth/auth.service";
import { UserService } from "src/app/services/user/user.service";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-connect-with",
  templateUrl: "./connect-with.component.html",
  styleUrls: ["./connect-with.component.scss"],
})
export class ConnectWithComponent implements OnInit, AfterViewInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.user && params.jwt) {
        this.userService.get(params.jwt).subscribe(
          (res) => {
            if (res.role.type == "admin" || res.role.type == "super_admin") {
              this.userService.getById(params.user, params.jwt).subscribe(
                (userData) => {
                  let userJson = User.toJson(userData, params.jwt, true,userData.role.type);
                  if (userJson != null) {
                    this.logout();
                    localStorage.setItem(
                      "studiomapUser",
                      JSON.stringify(userJson)
                    );
                    this.authService.callCurrentUserSubject(userJson);
                    console.log("0");
                    Webflow.myAction(this.router,"dashboard", {});
                  } else {
                    console.log("00");
                    Webflow.myAction(this.router,"dashboard", {});
                  }
                },
                (err) => {
                  console.log("000");
                  Webflow.myAction(this.router,"dashboard", {});
                }
              );
            } else {
              console.log("0000");
              Webflow.myAction(this.router,"dashboard", {});
            }
          },
          (err) => {
            console.log("00000");
            Webflow.myAction(this.router,"dashboard", {});
          }
        );
      } else {
        console.log("000000");
        Webflow.myAction(this.router,"dashboard", {});
      }
    });
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  logout() {
    localStorage.removeItem("studiomapUser");
    this.authService.callCurrentUserSubject(null);
  }
}
